// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash, FaEnvelope, FaLock, FaUserShield } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// function CreateSubadmin() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     status: "active",
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const getAuthToken = () => localStorage.getItem("token");

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));

//     if (errors[name]) {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         [name]: null,
//       }));
//     }
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     let isValid = true;

//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required.";
//       isValid = false;
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = "Email address is invalid.";
//       isValid = false;
//     }

//     if (!formData.password.trim()) {
//       newErrors.password = "Password is required.";
//       isValid = false;
//     } else if (formData.password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters long.";
//       isValid = false;
//     }

//     if (!formData.status) {
//       newErrors.status = "Status is required.";
//       isValid = false;
//     }

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire({
//         icon: "error",
//         title: "Validation Error",
//         text: "Please correct the errors in the form.",
//       });
//       return;
//     }

//     setLoading(true);

//     try {
//       const token = getAuthToken();
//       if (!token) {
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       const response = await fetch(`${API_URL}/sub-admin-create`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(formData),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to create sub-admin.");
//       }

//       const result = await response.json();
//       if (result.success == "1") {
//         Swal.fire(
//           "Success",
//           result.message || "Sub-admin created successfully!",
//           "success"
//         ).then(() => {
//           navigate("/allsubadmin");
//         });

//         setFormData({
//           email: "",
//           password: "",
//           status: "active",
//         });
//         setErrors({});
//       } else {
//         Swal.fire("Error", result.message || "Failed to create sub-admin.", "error");
//       }
//     } catch (err) {
//       console.error("Error creating sub-admin:", err);
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         width: "100%",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "30px",
//         boxSizing: "border-box",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       {/* 🎯 Page Header */}
//       <div
//         style={{
//           maxWidth: "1200px",
//           margin: "0 auto 24px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "14px",
//             marginBottom: "6px",
//           }}
//         >
//           <div
//             style={{
//               width: "52px",
//               height: "52px",
//               borderRadius: "14px",
//               background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#ffffff",
//               fontSize: "24px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//             }}
//           >
//             <FaUserShield />
//           </div>
//           <div>
//             <h1
//               style={{
//                 margin: 0,
//                 fontSize: "26px",
//                 fontWeight: "800",
//                 color: "#1e3a5f",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               Create Sub Admin
//             </h1>
//             <p
//               style={{
//                 margin: "2px 0 0",
//                 fontSize: "13.5px",
//                 color: "#64748b",
//                 fontWeight: "500",
//               }}
//             >
//               Fill in the details below to add a new sub admin to your team
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* 🎯 Main Form Area — Full Width */}
//       <div
//         style={{
//           maxWidth: "1200px",
//           margin: "0 auto",
//           background: "#ffffff",
//           borderRadius: "20px",
//           boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//           border: "1.5px solid #e2e8f0",
//           overflow: "hidden",
//         }}
//       >
//         {/* Gradient Top Bar */}
//         <div
//           style={{
//             height: "5px",
//             background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//           }}
//         />

//         <form onSubmit={handleSubmit} style={{ padding: "36px 40px 40px" }}>
//           {/* 🎯 Two Column Layout */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "24px",
//               marginBottom: "24px",
//             }}
//           >
//             {/* Email */}
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   color: "#1e3a5f",
//                   marginBottom: "8px",
//                   letterSpacing: "0.3px",
//                 }}
//               >
//                 Email Address
//               </label>
//               <div style={{ position: "relative" }}>
//                 <span
//                   style={{
//                     position: "absolute",
//                     left: "14px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#1e5799",
//                     fontSize: "14px",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   <FaEnvelope />
//                 </span>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="admin@example.com"
//                   value={formData.email}
//                   onChange={handleChange}
//                   style={{
//                     width: "100%",
//                     padding: "13px 14px 13px 42px",
//                     borderRadius: "12px",
//                     border: errors.email
//                       ? "1.5px solid #dc2626"
//                       : "1.5px solid #e2e8f0",
//                     background: "#f8fafc",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     transition: "all 0.25s ease",
//                     boxSizing: "border-box",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = "#1e5799";
//                     e.target.style.background = "#ffffff";
//                     e.target.style.boxShadow = "0 0 0 4px rgba(30, 87, 153, 0.1)";
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = errors.email
//                       ? "#dc2626"
//                       : "#e2e8f0";
//                     e.target.style.background = "#f8fafc";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//               </div>
//               {errors.email && (
//                 <p
//                   style={{
//                     color: "#dc2626",
//                     fontSize: "12px",
//                     margin: "6px 0 0",
//                     fontWeight: "600",
//                   }}
//                 >
//                   {errors.email}
//                 </p>
//               )}
//             </div>

//             {/* Password */}
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   color: "#1e3a5f",
//                   marginBottom: "8px",
//                   letterSpacing: "0.3px",
//                 }}
//               >
//                 Password
//               </label>
//               <div style={{ position: "relative" }}>
//                 <span
//                   style={{
//                     position: "absolute",
//                     left: "14px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#1e5799",
//                     fontSize: "14px",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   <FaLock />
//                 </span>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   name="password"
//                   placeholder="Enter password (min 6 chars)"
//                   value={formData.password}
//                   onChange={handleChange}
//                   style={{
//                     width: "100%",
//                     padding: "13px 44px 13px 42px",
//                     borderRadius: "12px",
//                     border: errors.password
//                       ? "1.5px solid #dc2626"
//                       : "1.5px solid #e2e8f0",
//                     background: "#f8fafc",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     transition: "all 0.25s ease",
//                     boxSizing: "border-box",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = "#1e5799";
//                     e.target.style.background = "#ffffff";
//                     e.target.style.boxShadow = "0 0 0 4px rgba(30, 87, 153, 0.1)";
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = errors.password
//                       ? "#dc2626"
//                       : "#e2e8f0";
//                     e.target.style.background = "#f8fafc";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//                 <span
//                   onClick={() => setShowPassword(!showPassword)}
//                   style={{
//                     position: "absolute",
//                     right: "14px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer",
//                     color: "#64748b",
//                     fontSize: "16px",
//                     userSelect: "none",
//                     transition: "color 0.2s ease",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.color = "#1e5799")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.color = "#64748b")
//                   }
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </span>
//               </div>
//               {errors.password && (
//                 <p
//                   style={{
//                     color: "#dc2626",
//                     fontSize: "12px",
//                     margin: "6px 0 0",
//                     fontWeight: "600",
//                   }}
//                 >
//                   {errors.password}
//                 </p>
//               )}
//             </div>
//           </div>

//           {/* Status — Full Width */}
//           <div style={{ marginBottom: "30px" }}>
//             <label
//               style={{
//                 display: "block",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 color: "#1e3a5f",
//                 marginBottom: "8px",
//                 letterSpacing: "0.3px",
//               }}
//             >
//               Status
//             </label>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "14px",
//               }}
//             >
//               {/* Active Option */}
//               <div
//                 onClick={() => setFormData({ ...formData, status: "active" })}
//                 style={{
//                   padding: "14px 18px",
//                   borderRadius: "12px",
//                   border:
//                     formData.status === "active"
//                       ? "2px solid #1e5799"
//                       : "1.5px solid #e2e8f0",
//                   background:
//                     formData.status === "active" ? "#e8f1fb" : "#f8fafc",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "12px",
//                   transition: "all 0.25s ease",
//                 }}
//                 onMouseEnter={(e) => {
//                   if (formData.status !== "active") {
//                     e.currentTarget.style.borderColor = "#c7ddf3";
//                     e.currentTarget.style.background = "#f0f7ff";
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   if (formData.status !== "active") {
//                     e.currentTarget.style.borderColor = "#e2e8f0";
//                     e.currentTarget.style.background = "#f8fafc";
//                   }
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "36px",
//                     height: "36px",
//                     borderRadius: "10px",
//                     background:
//                       formData.status === "active" ? "#1e5799" : "#e2e8f0",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "16px",
//                     color: "#ffffff",
//                     transition: "all 0.25s ease",
//                   }}
//                 >
//                   ✓
//                 </div>
//                 <div>
//                   <div
//                     style={{
//                       fontSize: "14px",
//                       fontWeight: "700",
//                       color:
//                         formData.status === "active" ? "#1e5799" : "#334155",
//                     }}
//                   >
//                     Active
//                   </div>
//                   <div
//                     style={{
//                       fontSize: "11.5px",
//                       color: "#64748b",
//                       fontWeight: "500",
//                     }}
//                   >
//                     Sub admin can log in
//                   </div>
//                 </div>
//               </div>

//               {/* Inactive Option */}
//               <div
//                 onClick={() => setFormData({ ...formData, status: "inactive" })}
//                 style={{
//                   padding: "14px 18px",
//                   borderRadius: "12px",
//                   border:
//                     formData.status === "inactive"
//                       ? "2px solid #dc2626"
//                       : "1.5px solid #e2e8f0",
//                   background:
//                     formData.status === "inactive" ? "#fef2f2" : "#f8fafc",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "12px",
//                   transition: "all 0.25s ease",
//                 }}
//                 onMouseEnter={(e) => {
//                   if (formData.status !== "inactive") {
//                     e.currentTarget.style.borderColor = "#fecaca";
//                     e.currentTarget.style.background = "#fef2f2";
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   if (formData.status !== "inactive") {
//                     e.currentTarget.style.borderColor = "#e2e8f0";
//                     e.currentTarget.style.background = "#f8fafc";
//                   }
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "36px",
//                     height: "36px",
//                     borderRadius: "10px",
//                     background:
//                       formData.status === "inactive" ? "#dc2626" : "#e2e8f0",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "16px",
//                     color: "#ffffff",
//                     transition: "all 0.25s ease",
//                   }}
//                 >
//                   ⛔
//                 </div>
//                 <div>
//                   <div
//                     style={{
//                       fontSize: "14px",
//                       fontWeight: "700",
//                       color:
//                         formData.status === "inactive" ? "#dc2626" : "#334155",
//                     }}
//                   >
//                     Inactive
//                   </div>
//                   <div
//                     style={{
//                       fontSize: "11.5px",
//                       color: "#64748b",
//                       fontWeight: "500",
//                     }}
//                   >
//                     Sub admin cannot log in
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* 🎯 Footer — Button + Note */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               paddingTop: "24px",
//               borderTop: "1.5px dashed #e2e8f0",
//               gap: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <p
//               style={{
//                 margin: 0,
//                 fontSize: "12.5px",
//                 color: "#94a3b8",
//                 fontWeight: "500",
//               }}
//             >
//               🔒 All fields are required. Password must be at least 6 characters.
//             </p>

//             <button
//               type="submit"
//               disabled={loading}
//               style={{
//                 padding: "13px 42px",
//                 borderRadius: "12px",
//                 border: "none",
//                 background: loading
//                   ? "#94a3b8"
//                   : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontSize: "14.5px",
//                 fontWeight: "800",
//                 letterSpacing: "0.5px",
//                 cursor: loading ? "not-allowed" : "pointer",
//                 transition: "all 0.3s ease",
//                 boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "8px",
//                 minWidth: "200px",
//               }}
//               onMouseEnter={(e) => {
//                 if (!loading) {
//                   e.currentTarget.style.transform = "translateY(-2px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 12px 32px rgba(30, 87, 153, 0.45)";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (!loading) {
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow =
//                     "0 8px 24px rgba(30, 87, 153, 0.3)";
//                 }
//               }}
//             >
//               {loading ? (
//                 <>
//                   <span
//                     style={{
//                       width: "16px",
//                       height: "16px",
//                       border: "2px solid rgba(255,255,255,0.3)",
//                       borderTop: "2px solid #ffffff",
//                       borderRadius: "50%",
//                       display: "inline-block",
//                       animation: "spin 0.8s linear infinite",
//                     }}
//                   />
//                   Creating...
//                 </>
//               ) : (
//                 <>+ Create Sub Admin</>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* Keyframes */}
//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//         @media (max-width: 768px) {
//           form > div:first-child {
//             grid-template-columns: 1fr !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default CreateSubadmin;

import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaEnvelope, FaLock, FaUserShield } from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL;

function CreateSubadmin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    status: "active",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const getAuthToken = () => localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email address is invalid.";
      isValid = false;
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
      isValid = false;
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long.";
      isValid = false;
    }

    if (!formData.status) {
      newErrors.status = "Status is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please correct the errors in the form.",
      });
      return;
    }

    setLoading(true);

    try {
      const token = getAuthToken();
      if (!token) {
        throw new Error("Authentication token not found. Please log in.");
      }

      const response = await fetch(`${API_URL}/sub-admin-create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to create sub-admin.");
      }

      const result = await response.json();
      if (result.success == "1") {
        Swal.fire(
          "Success",
          result.message || "Sub-admin created successfully!",
          "success"
        ).then(() => {
          navigate("/allsubadmin");
        });

        setFormData({
          email: "",
          password: "",
          status: "active",
        });
        setErrors({});
      } else {
        Swal.fire("Error", result.message || "Failed to create sub-admin.", "error");
      }
    } catch (err) {
      console.error("Error creating sub-admin:", err);
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "30px",
        boxSizing: "border-box",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      {/* 🎯 Page Header */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto 24px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginBottom: "6px",
          }}
        >
          <div
            style={{
              width: "52px",
              height: "52px",
              borderRadius: "14px",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "24px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
            }}
          >
            <FaUserShield />
          </div>
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: "26px",
                fontWeight: "800",
                color: "#1e3a5f",
                letterSpacing: "-0.5px",
              }}
            >
              Create Sub Admin
            </h1>
            <p
              style={{
                margin: "2px 0 0",
                fontSize: "13.5px",
                color: "#64748b",
                fontWeight: "500",
              }}
            >
              Fill in the details below to add a new sub admin to your team
            </p>
          </div>
        </div>
      </div>

      {/* 🎯 Main Form Area — Full Width */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: "20px",
          boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
          border: "1.5px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        {/* Gradient Top Bar */}
        <div
          style={{
            height: "5px",
            background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
          }}
        />

        <form onSubmit={handleSubmit} style={{ padding: "36px 40px 40px" }}>
          {/* 🎯 Two Column Layout (Email + Password) */}
          <div
            className="form-grid-2"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "24px",
              marginBottom: "24px",
            }}
          >
            {/* Email */}
            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "8px",
                  letterSpacing: "0.3px",
                }}
              >
                Email Address
              </label>
              <div style={{ position: "relative" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#1e5799",
                    fontSize: "14px",
                    pointerEvents: "none",
                  }}
                >
                  <FaEnvelope />
                </span>
                <input
                  type="email"
                  name="email"
                  placeholder="admin@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "13px 14px 13px 42px",
                    borderRadius: "12px",
                    border: errors.email
                      ? "1.5px solid #dc2626"
                      : "1.5px solid #e2e8f0",
                    background: "#f8fafc",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    outline: "none",
                    transition: "all 0.25s ease",
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#1e5799";
                    e.target.style.background = "#ffffff";
                    e.target.style.boxShadow = "0 0 0 4px rgba(30, 87, 153, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.email
                      ? "#dc2626"
                      : "#e2e8f0";
                    e.target.style.background = "#f8fafc";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>
              {errors.email && (
                <p
                  style={{
                    color: "#dc2626",
                    fontSize: "12px",
                    margin: "6px 0 0",
                    fontWeight: "600",
                  }}
                >
                  {errors.email}
                </p>
              )}
            </div>

            {/* Password */}
            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "8px",
                  letterSpacing: "0.3px",
                }}
              >
                Password
              </label>
              <div style={{ position: "relative" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#1e5799",
                    fontSize: "14px",
                    pointerEvents: "none",
                  }}
                >
                  <FaLock />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter password (min 6 chars)"
                  value={formData.password}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "13px 44px 13px 42px",
                    borderRadius: "12px",
                    border: errors.password
                      ? "1.5px solid #dc2626"
                      : "1.5px solid #e2e8f0",
                    background: "#f8fafc",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    outline: "none",
                    transition: "all 0.25s ease",
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#1e5799";
                    e.target.style.background = "#ffffff";
                    e.target.style.boxShadow = "0 0 0 4px rgba(30, 87, 153, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.password
                      ? "#dc2626"
                      : "#e2e8f0";
                    e.target.style.background = "#f8fafc";
                    e.target.style.boxShadow = "none";
                  }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#64748b",
                    fontSize: "16px",
                    userSelect: "none",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = "#1e5799")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = "#64748b")
                  }
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {errors.password && (
                <p
                  style={{
                    color: "#dc2626",
                    fontSize: "12px",
                    margin: "6px 0 0",
                    fontWeight: "600",
                  }}
                >
                  {errors.password}
                </p>
              )}
            </div>
          </div>

          {/* Status — Full Width */}
          <div style={{ marginBottom: "30px" }}>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "700",
                color: "#1e3a5f",
                marginBottom: "8px",
                letterSpacing: "0.3px",
              }}
            >
              Status
            </label>

            {/* ✅ Responsive Status Grid */}
            <div
              className="status-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {/* Active Option */}
              <div
                onClick={() => setFormData({ ...formData, status: "active" })}
                style={{
                  padding: "14px 18px",
                  borderRadius: "12px",
                  border:
                    formData.status === "active"
                      ? "2px solid #1e5799"
                      : "1.5px solid #e2e8f0",
                  background:
                    formData.status === "active" ? "#e8f1fb" : "#f8fafc",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  if (formData.status !== "active") {
                    e.currentTarget.style.borderColor = "#c7ddf3";
                    e.currentTarget.style.background = "#f0f7ff";
                  }
                }}
                onMouseLeave={(e) => {
                  if (formData.status !== "active") {
                    e.currentTarget.style.borderColor = "#e2e8f0";
                    e.currentTarget.style.background = "#f8fafc";
                  }
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    background:
                      formData.status === "active" ? "#1e5799" : "#e2e8f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    color: "#ffffff",
                    transition: "all 0.25s ease",
                    flexShrink: 0,
                  }}
                >
                  ✓
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color:
                        formData.status === "active" ? "#1e5799" : "#334155",
                    }}
                  >
                    Active
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "#64748b",
                      fontWeight: "500",
                    }}
                  >
                    Sub admin can log in
                  </div>
                </div>
              </div>

              {/* Inactive Option */}
              <div
                onClick={() => setFormData({ ...formData, status: "inactive" })}
                style={{
                  padding: "14px 18px",
                  borderRadius: "12px",
                  border:
                    formData.status === "inactive"
                      ? "2px solid #dc2626"
                      : "1.5px solid #e2e8f0",
                  background:
                    formData.status === "inactive" ? "#fef2f2" : "#f8fafc",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  if (formData.status !== "inactive") {
                    e.currentTarget.style.borderColor = "#fecaca";
                    e.currentTarget.style.background = "#fef2f2";
                  }
                }}
                onMouseLeave={(e) => {
                  if (formData.status !== "inactive") {
                    e.currentTarget.style.borderColor = "#e2e8f0";
                    e.currentTarget.style.background = "#f8fafc";
                  }
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    background:
                      formData.status === "inactive" ? "#dc2626" : "#e2e8f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    color: "#ffffff",
                    transition: "all 0.25s ease",
                    flexShrink: 0,
                  }}
                >
                  ⛔
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color:
                        formData.status === "inactive" ? "#dc2626" : "#334155",
                    }}
                  >
                    Inactive
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "#64748b",
                      fontWeight: "500",
                    }}
                  >
                    Sub admin cannot log in
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 🎯 Footer — Button + Note */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: "24px",
              borderTop: "1.5px dashed #e2e8f0",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "12.5px",
                color: "#94a3b8",
                fontWeight: "500",
              }}
            >
              🔒 All fields are required. Password must be at least 6 characters.
            </p>

            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "13px 42px",
                borderRadius: "12px",
                border: "none",
                background: loading
                  ? "#94a3b8"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "14.5px",
                fontWeight: "800",
                letterSpacing: "0.5px",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minWidth: "200px",
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 32px rgba(30, 87, 153, 0.45)";
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 24px rgba(30, 87, 153, 0.3)";
                }
              }}
            >
              {loading ? (
                <>
                  <span
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid rgba(255,255,255,0.3)",
                      borderTop: "2px solid #ffffff",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  Creating...
                </>
              ) : (
                <>+ Create Sub Admin</>
              )}
            </button>
          </div>
        </form>
      </div>

      {/* Keyframes + Responsive */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .form-grid-2 {
            grid-template-columns: 1fr !important;
          }

          .status-grid {
            grid-template-columns: 1fr !important;   /* ✅ Active + Inactive stack */
          }

          form {
            padding: 24px 20px 28px !important;
          }
        }

        @media (max-width: 480px) {
          .status-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}

export default CreateSubadmin;